export default __webpack_public_path__ + "static/amazonFires4-eae0399303232aace8c808f4862dcb09.gif";